export default __webpack_public_path__ + "94dea63e729949694de15e9d31878429.svg";